// extracted by mini-css-extract-plugin
export default {"styles":"RehabConsultProvider_styles__Pl9qs"};